<script lang="ts" setup>
import { useUserStore } from '@/stores/user'
import unknown from '@/assets/imgs/unknown.png'
import female from '@/assets/imgs/female.png'
import male from '@/assets/imgs/male.png'
import { commonStore } from '@/stores/common'
import { getImage } from '@/utils'
withDefaults(defineProps<{
  appName: string,
  // user: any,
  // common: any,
}>(), {
  appName: '',
})
const common = commonStore()
const user = useUserStore()
const router = useRouter()
function handlePerson() {
  router.push({ name: 'PersonalCenter' })
}
async function handleLogout() {
  await user.logout()
  router.push({ name: 'PasswordLogin' })
}

function handleMenuExpand() {
  common.isShowMenu = !common.isShowMenu
}

const expandImg = computed(() => {
  return getImage(common.isShowMenu ? 'collapse.png' : 'expend.png')
})

</script>

<template>
  <header class="jy-header">
    <div class="left">
      <div class="icon" @click="handleMenuExpand">
        <img :src="expandImg">
      </div>
      <div class="logo-text" @click="router.push('/')">
        {{ appName }}
      </div>
    </div>
    <div class="right">
      <el-dropdown>
        <div class="el-dropdown-link">
          <img :src="user.gender === 1 ? male : user.gender === 2 ? female : unknown" class="img-user">
          <span>个人中心</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="handlePerson">
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click="handleLogout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.jy-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  line-height: 60px;
  background-color: $color--primary;

  .right {
    display: flex;
    align-items: center;

    .el-dropdown {
      margin-right: 40px;
      font-size: 16px;
      color: $color--white;
    }

    div {
      display: flex;
      align-items: center;
      cursor: pointer;

      span {
        margin: 0 5px 0 10px;
      }

      .img-user {
        width: 32px;
        height: 32px;
        margin-left: 40px;
      }
    }

  }

  .left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .icon {
    width: 60px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    background-color: $color--primary-dark;
  }

  .logo-text {
    margin-left: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    color: #fefefe;
    cursor: pointer;
  }
}
</style>
